// extracted by mini-css-extract-plugin
export default {"button-list":"ButtonSettingsForm_button-list__fFsWM","form-button":"ButtonSettingsForm_form-button__3vO-J","two-input-row":"ButtonSettingsForm_two-input-row__DdCRu"};